export class JsonKeyPlaceholder {
    keyName: string = '';
    startIndex: number = 0;
    endIndex: number = 0;
    fullMatch: string = '';

    constructor() {}
}
